import { createSlice } from "@reduxjs/toolkit";

export const causesSlice = createSlice({
  name: 'causes',
  initialState: { causes: null, idCause: null },
  reducers: {
    getCauses: (state, { payload }) => {
      state.causes = payload
    },
    setCause: (state, { payload }) => {
      state.idCause = payload
    },
    resetCause: (state) => {
      state.idCause = null
    }
  }
});

export const { getCauses, setCause, resetCause } = causesSlice.actions